import { IsDefined } from 'class-validator';

export class BaseValue {
    @IsDefined()
    baseValueDefinitionId!: string;

    @IsDefined()
    value!: string | number;
}
